import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../../components/common/TextField';
import { formatDate, formatNumber } from '../../../../common/Util';
import ItemTitleSection from '../../../../components/ItemTitleSection';
import { SelectBox } from '../../../../components/common/SelectBox';
import DatePicker from '../../../../components/common/DatePicker';

//주택마련저축, 월세액
const HousingDetailItem2 = ({
  inputList,
  codeList = () => {},
  setDataList,
  handleChange,
  data,
  handleDeleteButton,
  dataIndex,
  title,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      {inputList.map((item, index) => {
        if (item.input === 'selectBox') {
          return (
            <React.Fragment key={index}>
              {index === 0 && (
                <ItemTitleSection
                  title={`${title}${dataIndex + 1}`}
                  handleDeleteButton={() => handleDeleteButton(dataIndex)}
                />
              )}
              <SelectBox
                disabled={item.key == 'htmKFlag' || disabled}
                name={item.key}
                label={item.label}
                onChange={e => handleChange(e, dataIndex)}
                value={data[item.key]}>
                {codeList(item.key, !disabled)}
              </SelectBox>
            </React.Fragment>
          );
        } else if (item.isDate) {
          //월세액 근무기간
          if (item.key === 'htm013' || item.key == 'htm011') {
            return (
              <div
                key={item.key}
                className="displayFlex"
                style={{ gap: '10px', alignItems: 'flex-end' }}>
                <DatePicker
                  disabled={disabled}
                  value={formatDate(data[item.key]?.replaceAll('-', ''))}
                  name={item.key}
                  label={item.label}
                  onChange={e => handleChange(e, dataIndex)}
                  endPosition="left"
                />
                <DatePicker
                  disabled={disabled}
                  value={formatDate(data[item.endKey]?.replaceAll('-', ''))}
                  name={item.endKey}
                  label={''}
                  onChange={e => handleChange(e, dataIndex)}
                  endPosition="right"
                />
              </div>
            );
          }
        } else {
          return (
            <TextField
              key={item.key}
              label={item.label}
              size="small"
              color={item.color}
              variant={item.variant}
              value={item.isNumber ? formatNumber(data[item.key]) : data[item.key]}
              name={item.key}
              onChange={e => handleChange(e, dataIndex)}
              disabled={item.disabled || disabled}
              inputStyle={{
                backgroundColor: item.color === 'secondary' ? 'var(--Primary-100)' : '',
              }}
            />
          );
        }
      })}
    </div>
  );
};

export default HousingDetailItem2;
